import { Col, Row, Space, Typography } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CleanButton from "../../../common/components/CleanButton";
import Page from "../../../common/components/Page";
import PageSummary from "../../../common/components/PageSummary";
import { LookupRequest } from "../../../models/lookup-request";
import { civilRequest } from "../../../state/connect-api";
import { useCivilCaseSummaryMutation } from "../../../state/globalApi";
import { setCivilMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import useCivilLookup from "../useCivilLookup";
import CivilCaseTab from "./civil-case-detail-tab";

const CivilDetail = () => {
  const [getCivilCaseSummary, { data }] = useCivilCaseSummaryMutation();
  const { activeCaseNumber } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const { handleReturnToResult, handleNewQuery } = useCivilLookup();

  useEffect(() => {
    const lookupRequest: LookupRequest = civilRequest(activeCaseNumber);
    const fetch = async () => {
      const summary = await getCivilCaseSummary(lookupRequest).unwrap();
      dispatch(setCivilMaster({ summary: summary }));
    };
    fetch();
  }, [activeCaseNumber, dispatch]);

  return (
    <Page>
      <Page.Title title="Case Details" icon="briefcase" />
      <Page.Toolbar>
        <CleanButton onClick={handleReturnToResult} icon="arrow-left">
          Return To Results
        </CleanButton>
        <CleanButton icon="plus" onClick={handleNewQuery}>
          New Query
        </CleanButton>
      </Page.Toolbar>
      <Page.Content>
        <Row gutter={16}>
          <Col xl={5} lg={4} md={4} sm={24} xs={24}>
            <br />
            <Space direction="vertical">
              <div style={{ textAlign: "center" }}>
                <PageSummary.Title title={localStorage.getItem("caseNumber")} />
                <PageSummary.Title subtitle={data?.MAIN[0]?.PrimaryPlaintiffName} />
                <p style={{ marginBottom: "0px" }}>{"VS"}</p>
                <PageSummary.Title subtitle={data?.MAIN[0]?.PrimaryDefendantName} />
              </div>
            </Space>
          </Col>
          <Col xl={19} lg={20} md={20} sm={24} xs={24}>
            <CivilCaseTab />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};

export default CivilDetail;
